import type { AxiosInstance } from 'axios';
import { createCrudService, type CrudService } from '../core/crud';
import type { Promotion, PromotionCreate, PromotionFilter } from '../data/promotion';

export function createPromotionService(client: AxiosInstance) {
  return createCrudService<Promotion, PromotionCreate, PromotionFilter>(
    client,
    '/sales/Promotion',
    'promotionId',
  );
}

export type PromotionService = CrudService<Promotion, PromotionCreate, PromotionFilter>;
